import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

const LAST_SHOWN_KEY = 'vp_catalog_help_toast_last_shown';
const SHOW_INTERVAL_MS = 24 * 60 * 60 * 1000;

function ShopCatalogHelpToast({ preset = 'prominent' }) {
  const location = useLocation();
  const [show, setShow] = useState(false);

  const isShopRoute = useMemo(() => {
    const path = location.pathname;
    return (
      path.startsWith('/tienda') ||
      path.startsWith('/producto') ||
      path.startsWith('/marcas') ||
      path.startsWith('/categorias') ||
      path === '/wishlist' ||
      path === '/cartDetail'
    );
  }, [location.pathname]);

  useEffect(() => {
    if (!isShopRoute) {
      setShow(false);
      return;
    }

    const lastShownRaw = localStorage.getItem(LAST_SHOWN_KEY);
    const lastShown = lastShownRaw ? Number(lastShownRaw) : 0;
    const now = Date.now();

    if (Number.isFinite(lastShown) && now - lastShown < SHOW_INTERVAL_MS) {
      return;
    }

    const timerId = window.setTimeout(() => {
      setShow(true);
      localStorage.setItem(LAST_SHOWN_KEY, String(Date.now()));
    }, 1200);

    return () => window.clearTimeout(timerId);
  }, [isShopRoute]);

  if (!isShopRoute || !show) {
    return null;
  }

  return (
    <div
      className={`shop-catalog-help-toast-wrapper shop-toast-preset-${preset} position-fixed end-0 p-3`}
      aria-live="polite"
      aria-atomic="true"
    >
      <div className="toast show text-dark bg-warning border border-warning-subtle shadow-lg" role="alert">
        <div className="toast-header bg-warning text-dark border-0">
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          <strong className="me-auto">No encuentras lo que buscas?</strong>
          <button
            type="button"
            className="btn-close"
            aria-label="Cerrar"
            onClick={() => setShow(false)}
          ></button>
        </div>

        <div className="toast-body">
          Estamos para ayudarte. Si no ves un producto en el catalogo, escribenos por WhatsApp y te acompañamos a cotizarlo sin compromiso. Haremos todo lo posible por conseguirlo para ti.
          <div className="mt-2 d-flex justify-content-end">
            <a
              href="https://wa.me/573012201583?text=Hola%20Vintage%20Pro%20Audio%2C%20quiero%20cotizar%20un%20producto%20que%20no%20veo%20en%20el%20catalogo."
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-sm btn-dark"
            >
              Hablar por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShopCatalogHelpToast;
